<!-- @format -->

<div class="pinned-content-spot hmf-py-s hmf-mt-0">
	<button
		class="hmf-padding-0 hmf-text-align-initial hmf-soft-radius"
		[attr.data-em]="row + '_' + column + '_' + pinnedContent.headline?.replace(replace, '')"
		[ngClass]="{'no-availability-data-height': !availabilityOnProductCardsEnabled}"
		(click)="goToPinnedContentUrl(pinnedContent.cta[0].link)">
		<div
			class="rs_card_layout pinned-content-image-container"
			[ngClass]="[pinnedContent.textColor ? pinnedContent.textColor : 'dark']">
			<span class="pinned-content-intersection-observation-block hmf-display-inline-block hmf-position-absolute"></span>
			<shared-media-component-media
				[altText]="pinnedContent.altText"
				[image]="pinnedContent.image"
				[imagePagePosition]="imagePagePosition()"
				[mobileImg]=""
				[visualAssets]="pinnedContent.visualAssets"
				[willLazyLoad]="lazyLoad()"
				[itemTitle]="
					pinnedContent.headline || pinnedContent.Subhead || pinnedContent.altText
				"></shared-media-component-media>
			<div
				class="{{ pinnedContent.textColor }}"
				[ngClass]="{
					'pinned-content-text-overlay-pl hmf-px-xs hmf-pb-xs hmf-pt-0':
						isPublicLands,
					'pinned-content-text-overlay': !isPublicLands
				}">
				<div
					class="pinned-content-text-headline hmf-m-0 hmf-body-bold-l"
					[ngClass]="{
						'hmf-display-m-xs hmf-pb-xs hmf-pb-m-s hmf-label-s hmf-text-transform-m-uppercase':
							isPublicLands
					}">
					{{ pinnedContent.headline }}
				</div>
				<div
					class="pinned-content-text-subhead hmf-m-0 hmf-body-s"
					[ngClass]="{ 'hmf-header-bold-m-m hmf-pb-xs hmf-pb-m-s': isPublicLands }">
					{{ pinnedContent.Subhead }}
				</div>
				@if (!isPublicLands) {
					<a
						hmf-button
						class="hmf-m-0 hmf-label-s"
						height="base"
						[ngClass]="{
							'white': pinnedContent.textColor === 'light',
							'black': pinnedContent.textColor !== 'light'
						}"
						[attr.variant]="'tertiary'"
						[text]="pinnedContent.cta[0].linkTitle"
						[href]="pinnedContent.cta[0].link"
						[dataEm]="row + '_' + column + '_' + pinnedContent.headline?.replace(replace, '')"
						[attr.altText]="pinnedContent.cta[0].linkTitle"
						[attr.aria-label]="pinnedContent.cta[0].linkTitle">
					</a>
				} @else {
					<a
						hmf-text-link
						class="hmf-label-s hmf-display-flex hmf-align-items-center hmf-justify-content-center pl-custom-button-colors"
						[attr.variant]="'marketing'"
						[text]="pinnedContent.cta[0].linkTitle"
						[href]="pinnedContent.cta[0].link"
						[dataEm]="row + '_' + column + '_' + pinnedContent.headline?.replace(replace, '')"
						[attr.altText]="pinnedContent.cta[0].linkTitle"
						[attr.aria-label]="pinnedContent.cta[0].linkTitle">
					</a>
				}
			</div>
		</div>
	</button>
</div>